import { ArrowUpRight, Star, Users } from "lucide-react";
import { Reveal } from "./Reveal";
import { PROPERTIES } from "../data/content";

const PropertyCard = ({ property, wide }) => (
  <article
    data-testid={`property-bento-card-${property.id}`}
    className={`group relative flex flex-col overflow-hidden rounded-[1.75rem] border border-[#E4DBD0] bg-white transition-shadow duration-500 hover:shadow-[0_30px_60px_-30px_rgba(32,27,23,0.35)] ${
      wide ? "md:col-span-2" : ""
    }`}
  >
    <div className={`relative overflow-hidden ${wide ? "aspect-[16/8]" : "aspect-[4/3]"}`}>
      <img
        src={property.image}
        alt={property.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
      />
      <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-[#FBF8F3]/90 px-3 py-1.5 backdrop-blur-sm">
        <Star className="h-3 w-3 fill-[#C4623C] text-[#C4623C]" />
        <span className="font-mono-accent text-[10px] tracking-[0.12em] text-[#201B17]">
          {property.badge ? property.badge : `${property.rating} · ${property.reviewsCount} reviews`}
        </span>
      </div>
    </div>
    <div className="flex flex-1 flex-col p-6 md:p-7">
      <p className="font-mono-accent text-[10px] uppercase tracking-[0.22em] text-[#C4623C]">
        {property.location}
      </p>
      <h3 className="font-serif-display mt-2 text-2xl leading-tight text-[#201B17] md:text-3xl">
        {property.name}
      </h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-[#63584E]">{property.description}</p>
      <div className="mt-6 flex items-center justify-between gap-4 border-t border-[#F0EAE0] pt-5">
        <span className="inline-flex items-center gap-2 font-mono-accent text-[10px] uppercase tracking-[0.14em] text-[#8C7F72]">
          <Users className="h-3.5 w-3.5" />
          {property.capacity}
        </span>
        <a
          href={property.airbnbUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`property-airbnb-link-${property.id}`}
          className="group/link inline-flex items-center gap-1.5 text-xs font-medium text-[#C4623C] transition-colors duration-300 hover:text-[#201B17]"
        >
          Book on Airbnb
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
        </a>
      </div>
    </div>
  </article>
);

export const Properties = () => (
  <section id="properties" data-testid="properties-section" className="bg-[#F4EFE6] py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <Reveal>
          <p className="font-mono-accent text-[11px] uppercase tracking-[0.28em] text-[#C4623C]">
            The ALMAH collection
          </p>
          <h2 className="font-serif-display mt-5 max-w-xl text-4xl leading-[1.05] tracking-tight text-[#201B17] sm:text-5xl lg:text-6xl">
            Three sky homes, <em className="text-[#C4623C]">personally</em> hosted.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-sm leading-relaxed text-[#63584E]">
            No agencies, no middlemen. Every apartment is styled, stocked and
            cared for by our own hands between each stay.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {PROPERTIES.map((property, i) => (
          <Reveal
            key={property.id}
            delay={i * 0.08}
            className={i === 0 ? "md:col-span-2" : ""}
          >
            <PropertyCard property={property} wide={i === 0} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
